import React, { useState, useEffect, useRef } from "react";
import "../../../../node_modules/video-react/dist/video-react.css"; // import css
import { Player } from "video-react";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf"; // Import pdfjs from react-pdf
import { IP } from "../../../internalServer";
import "./ChapterVideo.css";
import CreateCategoryPopUp from "../../Popup/createCategoryPopUp";
import AddContentDetail from "../AddContentDetail/AddContentDetail";
import CreateNewEditer from "../CreateNewTextEditer/CreateNewEditer";
import { useLocation } from "react-router-dom";
import axios from "../../../axios";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { useNavigate } from "react-router-dom";
import PlayerComponent from "./PlayerComponent";
import MediaRenderer from "./MediaRenderer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import { CircularProgress, Tooltip, Typography } from "@mui/material";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.js`;

export default function ChapterVideo({ create }) {
  //This state is added by kuldeep
  const { state } = useLocation();
  const navigate = useNavigate();
  const viewerRef = useRef(null);
  const [chapterName, setChapterName] = useState();
  const [clickedContent, setClickedContent] = useState();
  const [contentData, setContentData] = useState([]);
  const [clickedBook, setClickedBook] = useState("");
  const [pdfLoading, setPdfLoading] = useState(true);
  const poster = "";
  const [openSubject, setOpenSubject] = useState({
    Class: true,
    ChapterContent: false,
    ChapterContent2: false,
    AddContent: false,
    AddCategry: false,
    isEditerOpen: false,
  });
  const helper = (a) => {
    const str = a;
    const startsWithDot = str?.startsWith(".");
    if (startsWithDot) {
      let p = a.replace(/^\./, "");
      p = IP + p;
      return p;
    } else {
      return a;
    }
  };
  const [navVal, setNavVal] = useState([]);
  const [sectionId, setSection] = useState();
  const [standardId, setStandard] = useState();
  const [standardName, setStandardName] = useState();
  const [sectionName, setSectionName] = useState();
  const [subjectId, setSubjectId] = useState();
  const [subjectName, setSubjectName] = useState();

  useEffect(() => {
    let index1 = localStorage.getItem("LibraryIndex");
    let LbNav = JSON.parse(localStorage.getItem("LibraryNav"));
    setNavVal(JSON.parse(localStorage.getItem("LibraryNav")));
    setSection(LbNav[index1][state.subIndex].sectionId);
    let res1 = JSON.parse(localStorage.getItem("clickedChapter"));
    if (res1) {
      setClickedBook(res1);
    }
    //Remove duplicate sectionId
    setStandard(LbNav[index1][state.subIndex].standardId);
    setSubjectId(LbNav[index1][state.subIndex]?.subjectId?.id);
    setSubjectName(LbNav[index1][state.subIndex]?.subjectId?.name);
    handleStdSec(
      LbNav[index1][state.subIndex].sectionId,
      LbNav[index1][state.subIndex].standardId,
    );
    handleContent();
  }, []);

  const handleStdSec = async (sectionId, standardId) => {
    const res = await axios.get(`/api/v1/school/section/get/${sectionId}`);
    setSectionName(res.data.data.name);
    const res1 = await axios.get(`/api/v1/school/standard/get/${standardId}`);
    setStandardName(res1.data.data.name);
  };
  const handleContent = async () => {
    try {
      let res = await axios.get(
        `/api/v1/cm/library/book/getLeftPaneByChapterId?chapter_id=${state.chapter_id}`,
      );
      console.log("res>>", res);

      console.log(res);
      setChapterName(res.data.data[0].chapterName);
      setContentData(res.data.data[0].chapterCategoryID);
      const firstContent =
        res?.data?.data?.[0]?.chapterCategoryID?.[0]?.contentInfoID?.[0];

      setClickedContent(firstContent || null);
    } catch (err) {
      console.log("error : ", err);
    }
  };

  const [contentOpenState, setContentOpenState] = useState([]);
  useEffect(() => {
    if (contentData.length > 0) {
      const initialState = new Array(contentData.length).fill(false);
      initialState[0] = true;
      initialState[1] = true;
      setContentOpenState(initialState);
    }
  }, [contentData]);

  const handelCLick1 = () => {
    if (openSubject.Class) {
      setOpenSubject({
        ...openSubject,
        Class: false,
      });
    } else {
      setOpenSubject({
        ...openSubject,
        Class: true,
      });
    }
  };

  const handelCLick2 = (index) => {
    const updatedOpenState = [...contentOpenState];
    updatedOpenState[index] = !updatedOpenState[index];
    setContentOpenState(updatedOpenState);
  };
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  const [numPages, setNumPages] = useState(null);

  const handleFullScreen = () => {
    if (viewerRef.current) {
      if (viewerRef.current.requestFullscreen) {
        viewerRef.current.requestFullscreen();
      } else if (viewerRef.current.webkitRequestFullscreen) {
        viewerRef.current.webkitRequestFullscreen();
      } else if (viewerRef.current.msRequestFullscreen) {
        viewerRef.current.msRequestFullscreen();
      }
    }
  };

  useEffect(() => {
    if (
      clickedContent?.fileInfo?.fileType === "pdf" ||
      clickedContent?.fileInfo?.fileType === "e-book"
    ) {
      setPdfLoading(true);
    }
  }, [clickedContent]);

  function convertSecondsToMinutes(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}min ${remainingSeconds}sec`;
  }
  return (
    <div
      className="orange-scrollBar"
      style={{ height: "calc(100vh - 120px)", overflowY: "scroll" }}
    >
      <div className="d-flex justify-content-between flex-wrap libBtn">
        <div className="d-flex align-items-center">
          <div
            className="path_subject_library"
            onClick={() => {
              navigate("/contentLibrary");
            }}
          >
            Library &nbsp;&#62;&nbsp;
          </div>
          <div
            className="path_subject_library"
            onClick={() => {
              navigate("/contentLibrary");
            }}
          >
            {standardName} {sectionName} &nbsp;&#62;&nbsp;
          </div>
          <div
            className="path_subject_library"
            onClick={() => {
              //Here added state for pass the id
              navigate("/library/subjectDetails", {
                state: {
                  subjectId: subjectId,
                  standardId: standardId,
                  sectionId: sectionId,
                  indexSub: state.subIndex,
                },
              });
            }}
          >
            {subjectName} &nbsp;&#62;&nbsp;
          </div>
          <div className="path_subject_library">{chapterName}</div>
        </div>
        {/* <div className="d-flex gap-2 flex-wrap">
          <div
            onClick={(e) =>
              setOpenSubject({
                ...openSubject,
                AddContent: true,
              })
            }
            className="  gap-2 AddContent_btn p-2"
          >
            <img src="/ContentM_images/add icon.svg" alt="add logo" />
            <span>Add Content</span>
          </div>
        </div> */}
      </div>

      <div className="mt-3 d-flex justify-content-between flex-wrap">
        {openSubject.isEditerOpen ? (
          <CreateNewEditer />
        ) : (
          <>
            <div className="vidio_player">
              {clickedContent?.fileInfo?.fileType === "pdf" ||
              clickedContent?.fileInfo?.fileType === "e-book" ? (
                <div
                  className="pdf-canvas-container"
                  ref={viewerRef}
                  style={{ position: "relative", backgroundColor: "#f5f5f5" }}
                >
                  {/* Material UI Circular Progress Loader */}
                  {pdfLoading && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#fafafa",
                        zIndex: 10,
                        gap: "16px",
                      }}
                    >
                      <CircularProgress
                        size={50}
                        thickness={4}
                        sx={{ color: "#ff9800" }} // Orange color - change as needed
                      />
                      <Typography
                        variant="body2"
                        sx={{ color: "#666", fontWeight: 500 }}
                      >
                        Loading PDF...
                      </Typography>
                    </div>
                  )}

                  <iframe
                    src={`${helper(
                      clickedContent?.fileInfo?.fileURL,
                    )}#toolbar=0&navpanes=0&scrollbar=0`}
                    title="pdf"
                    className="h-100 w-100"
                    onLoad={() => setPdfLoading(false)}
                    style={{
                      opacity: pdfLoading ? 0 : 1,
                      transition: "opacity 0.3s ease-in-out",
                      border: "none",
                    }}
                  />
                </div>
              ) : (
                <MediaRenderer
                  clickedContent={clickedContent}
                  contentProviderType={
                    clickedContent?.fileInfo?.contentProviderID
                      ?.contentProviderType
                  }
                  helper={helper}
                />
              )}
              <div className="video_titles mt-4">Title</div>
              {clickedContent !== undefined ? (
                <div className="Video_header_detail">
                  {clickedContent?.fileInfo?.fileName}
                </div>
              ) : (
                <div className="Video_header_detail">No Information.</div>
              )}
              <div className="video_titles">Description</div>
              {clickedContent !== undefined ? (
                <div className="Video_header_detail">
                  {clickedContent.contentDescription}
                </div>
              ) : (
                <div className="Video_header_detail">No Information.</div>
              )}
              <div className="video_titles">Content Length & Type</div>
              {clickedContent !== undefined ? (
                <div className="Video_header_detail">
                  {clickedContent?.fileInfo?.fileType === "img" ||
                  clickedContent?.fileInfo?.fileType === "png" ||
                  clickedContent?.fileInfo?.fileType === "jpg"
                    ? "1"
                    : clickedContent?.fileInfo?.fileType === "e-book"
                      ? clickedContent?.fileInfo?.fileLength
                      : convertSecondsToMinutes(
                          clickedContent?.fileInfo?.fileLength,
                        )}{" "}
                  {clickedContent?.fileInfo?.fileType === "audio" ||
                  clickedContent?.fileInfo?.fileType === "video" ||
                  clickedContent?.fileInfo?.fileType === "mp4" ||
                  clickedContent?.fileInfo?.fileType === "mp3"
                    ? ""
                    : "pages"}{" "}
                  • {clickedContent?.fileInfo?.fileType}
                </div>
              ) : (
                <div className="Video_header_detail">No Information.</div>
              )}
              <div className="video_titles">Posted on</div>
              {clickedContent !== undefined ? (
                <div className="">
                  {
                    <div className="Video_header_detail">
                      {formatDate(clickedContent?.fileInfo?.filePostedTime)}
                    </div>
                  }
                </div>
              ) : (
                <div className="Video_header_detail">No Information.</div>
              )}
              <div className="video_titles">Chapter & Book</div>
              {clickedContent !== undefined ? (
                <div className="Video_header_detail">
                  {`${chapterName} ${clickedBook?.name}`}
                </div>
              ) : (
                <div className="Video_header_detail">No Information.</div>
              )}
              <div className="video_titles">Author</div>
              {clickedContent !== undefined ? (
                <div className="Video_header_detail">
                  {clickedContent?.fileInfo?.author_name}
                </div>
              ) : (
                <div className="Video_header_detail">No Information.</div>
              )}
              {(clickedContent?.fileInfo?.fileType === "pdf" ||
                clickedContent?.fileInfo?.fileType === "e-book") && (
                <Tooltip
                  title="Full Screen"
                  arrow
                  placement="top"
                  enterDelay={200}
                  leaveDelay={100}
                >
                  <button
                    className="fullscreenbutton"
                    onClick={handleFullScreen}
                  >
                    <FontAwesomeIcon icon={faExpand} />{" "}
                  </button>
                </Tooltip>
              )}
            </div>
          </>
        )}

        <div className="Total_decription_rightSide">
          <div
            onClick={handelCLick1}
            className="d-flex gap-2 justify-content-between total_chapter_dropdown"
          >
            <div className="chapter_dropdown_heder">{chapterName}</div>
            {openSubject.Class ? (
              <img
                src="/ContentM_images/UpwordArrow.svg"
                alt="arrow logo"
              ></img>
            ) : (
              <img src="/ContentM_images/downArrow.svg" alt="arrow logo"></img>
            )}
          </div>
          {openSubject.Class && (
            <div>
              {/* <div
                className="addCategory d-flex justify-content-end my-2"
                onClick={(e) =>
                  setOpenSubject({
                    ...openSubject,
                    AddCategry: true,
                  })
                }
              >
                + Add new category
              </div> */}
              {/* //////////////////////////////  1.1 drodown ///////// */}
              {contentData.length > 0 &&
                contentData.map((obj, index) => (
                  <div>
                    <div
                      className="d-flex justify-content-between allChapterText"
                      onClick={() => {
                        handelCLick2(index);
                      }}
                      key={index}
                    >
                      <div className="d-flex gap-2">
                        <span className="FirstCircle ">1.{index + 1}</span>
                        <div>
                          <div className="text_books">{obj.CategoryName}</div>
                          <div className="textBokkSubcontain ">
                            {obj.contentInfoID.length} study materials
                          </div>
                        </div>
                      </div>
                      <div>
                        {contentOpenState[index] ? (
                          <img
                            src="/ContentM_images/UpwordArrow.svg"
                            alt="arrow logo"
                          ></img>
                        ) : (
                          <img
                            src="/ContentM_images/downArrow.svg"
                            alt="arrow logo"
                          ></img>
                        )}
                      </div>
                    </div>
                    {!contentOpenState[index] &&
                      index !== contentOpenState.length - 1 && (
                        <div
                          style={{
                            borderLeft: "3px solid orange",
                            height: "10px",
                            marginLeft: "20px",
                          }}
                        ></div>
                      )}
                    {contentOpenState[index] && (
                      <div className="hell">
                        {contentData[index]?.contentInfoID?.length > 0 &&
                          contentData[index]?.contentInfoID?.map(
                            (obj, index) => (
                              <div
                                style={{ cursor: "pointer" }}
                                className="d-flex justify-content-between flex-wrap align-items-center ml-3"
                                onClick={() => {
                                  setClickedContent(obj);
                                }}
                                key={index}
                              >
                                <div className="d-flex gap-2 ml-2 mb-1">
                                  <img
                                    src="/ContentM_images/ThreeBlackLine.svg"
                                    alt="List logo"
                                  ></img>
                                  {obj?.fileInfo?.fileType === "audio" && (
                                    <img
                                      src="/ContentM_images/SoundIcon.svg"
                                      alt="sound logo"
                                      className="iconSTyl"
                                    ></img>
                                  )}
                                  {obj?.fileInfo?.fileType === "mp3" && (
                                    <img
                                      src="/ContentM_images/SoundIcon.svg"
                                      alt="sound logo"
                                    ></img>
                                  )}
                                  {(obj?.fileInfo?.fileType === "pdf" ||
                                    obj?.fileInfo?.fileType === "e-book") && (
                                    <img
                                      src="/ContentM_images/PdfBlackIcon.svg"
                                      alt="sound logo"
                                    ></img>
                                  )}
                                  {obj?.fileInfo?.fileType === "img" && (
                                    <img
                                      src="/ContentM_images/PdfBlackIcon.svg"
                                      alt="sound logo"
                                    ></img>
                                  )}
                                  {obj?.fileInfo?.fileType === "png" && (
                                    <img
                                      src="/ContentM_images/PdfBlackIcon.svg"
                                      alt="sound logo"
                                    ></img>
                                  )}
                                  {obj?.fileInfo?.fileType === "jpg" && (
                                    <img
                                      src="/ContentM_images/PdfBlackIcon.svg"
                                      alt="sound logo"
                                    ></img>
                                  )}
                                  {obj?.fileInfo?.fileType === "svg" && (
                                    <img
                                      src="/ContentM_images/PdfBlackIcon.svg"
                                      alt="sound logo"
                                    ></img>
                                  )}
                                  {obj?.fileInfo?.fileType === "video" && (
                                    <img
                                      src="/ContentM_images/PlayIcon.svg"
                                      alt="sound logo"
                                    ></img>
                                  )}
                                  {obj?.fileInfo?.fileType === "mp4" && (
                                    <img
                                      src="/ContentM_images/PlayIcon.svg"
                                      alt="sound logo"
                                    ></img>
                                  )}
                                  <div>
                                    <div
                                      className={
                                        clickedContent === obj
                                          ? "chapterDropdownDetailClicked"
                                          : "chapterDropdownDetail"
                                      }
                                    >
                                      {obj?.fileInfo?.fileName}
                                    </div>
                                    <div className="audio_list">
                                      {obj?.fileInfo?.fileType === "img" ||
                                      obj?.fileInfo?.fileType === "jpg" ||
                                      obj?.fileInfo?.fileType === "png"
                                        ? "image"
                                        : convertSecondsToMinutes(
                                            obj?.fileInfo?.fileLength,
                                          )}{" "}
                                      {obj?.fileInfo?.fileType === "audio" &&
                                        "audio"}
                                      {obj?.fileInfo?.fileType === "mp3" &&
                                        "audio"}
                                      {obj?.fileInfo?.fileType === "video" &&
                                        "min"}
                                      {obj?.fileInfo?.fileType === "mp4" &&
                                        "min"}
                                      {obj?.fileInfo?.fileType === "pdf" &&
                                        "pages"}
                                      {obj?.fileInfo?.fileType === "e-book" &&
                                        "pages"}
                                      {/* {obj.fileInfo.fileType === "img" && ""}
                                      {obj.fileInfo.fileType === "jpg" && ""}
                                      {obj.fileInfo.fileType === "png" &&
                                        ""} •{" "} */}
                                      {obj?.fileInfo?.fileType === "img" ||
                                      obj?.fileInfo?.fileType === "jpg" ||
                                      obj?.fileInfo?.fileType === "png"
                                        ? " "
                                        : "•"}{" "}
                                      {obj?.fileInfo?.fileType === "audio" &&
                                        "audio"}
                                      {obj?.fileInfo?.fileType === "mp3" &&
                                        "audio"}
                                      {obj?.fileInfo?.fileType === "video" &&
                                        "video"}
                                      {obj?.fileInfo?.fileType === "mp4" &&
                                        "video"}
                                      {obj?.fileInfo?.fileType === "pdf" &&
                                        "e-book"}
                                      {obj?.fileInfo?.fileType === "e-book" &&
                                        "e-book"}
                                      {obj?.fileInfo?.fileType === "img" &&
                                        "img"}
                                      {obj?.fileInfo?.fileType === "png" &&
                                        "img"}
                                      {obj?.fileInfo?.fileType === "jpg" &&
                                        "img"}
                                    </div>
                                  </div>
                                </div>
                                {/* <img
                                src="/ContentM_images/menuDotsCm.svg"
                                alt="menu logo"
                              ></img> */}
                              </div>
                            ),
                          )}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
      {openSubject.AddContent && (
        <AddContentDetail setOpenSubject={setOpenSubject} />
      )}
      {openSubject.AddCategry && (
        <CreateCategoryPopUp
          setOpenSubject={setOpenSubject}
          data={state.chapter_id}
        />
      )}
    </div>
  );
}
